import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import type { BrandAccountingCode, TFormCreateBeneficiar } from "components/BeneficiaryFormContainer/types";
import ModalBox from "components/Modal";
import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import { useMemo, useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { IBrand } from "store/brandStore";

import AddBrandAccountingCode from "../AddBrandAccountingCode";

interface IBrandAccountingCodes {
    brands: IBrand[];
}
const BrandAccountingCodes = ({ brands }: IBrandAccountingCodes) => {
    const { control, reset } = useFormContext<TFormCreateBeneficiar>();

    const { append, fields } = useFieldArray({
        control,
        name: "brandAccountingCode",
    });

    const [t] = useTranslation();
    const [modalType, setModalType] = useState("");
    const [brandChosen, setBrandChosen] = useState<IBrand | null>(null);

    // Brands to display if they want to add an account number (all except Default one and those already chosen):
    const companyBrands = useMemo(() => {
        const brandsToUse = brands.filter(
            (brand) =>
                brand.name !== "Par défaut" && !fields?.find((brandAccount) => brandAccount.brandId === brand.id),
        );
        return brandsToUse.map((item) => item.name);
    }, [brands, fields]);

    // Displays input for adding a brand accounting number.
    const handleAddAccountBrand = () => {
        if (brandChosen) {
            const newBrandAccount = { brand: brandChosen.name, brandId: brandChosen.id as number, accountingCode: "" };
            append(newBrandAccount);
            // append dirty all fields, this line prevent from this
            reset({}, { keepValues: true });
        }
        setModalType("");
        setBrandChosen(null);
    };

    return (
        <>
            <ModalBox
                open={modalType === "add-brand"}
                onClose={() => {
                    setModalType(""), setBrandChosen(null);
                }}
                mainTitle={t("BrandAccountingCode.AddBrand")}
            >
                <AddBrandAccountingCode
                    companyBrands={companyBrands}
                    setBrandChosen={setBrandChosen}
                    handleAddAccountBrand={handleAddAccountBrand}
                />
            </ModalBox>
            <div className="brand-accounting-number">
                {fields?.map((brand: BrandAccountingCode, i: number) => {
                    return (
                        <div className="accounting-number-field my-2!" key={brand.accountingCode}>
                            <span className="brand-name">
                                {t("BrandAccountingCode.CodeFor", { brandName: brand.brand })}
                            </span>
                            <TextFormComponent
                                control={control}
                                controlName={`brandAccountingCode.${i}.accountingCode`}
                            />
                        </div>
                    );
                })}
                <div className="add-channel-button" onClick={() => setModalType("add-brand")}>
                    <AddOutlinedIcon sx={{ width: 18, height: 18 }} />
                    {t("BrandAccountingCode.AddBrand")}
                </div>
            </div>
        </>
    );
};

export default BrandAccountingCodes;
